// Duyuru takip: Okudu ve anladı / Gördü / Henüz görmedi firmalar
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Download, Search } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const dt = (s) => (s ? new Date(s).toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' }) : '-');

const Table = ({ rows, kind }) => (
  rows.length === 0 ? <p className="py-6 text-center text-sm text-slate-400" data-testid={`ua-track-empty-${kind}`}>Kayıt yok</p> : (
    <div className="overflow-x-auto rounded-lg border">
      <table className="w-full text-sm" data-testid={`ua-track-table-${kind}`}>
        <thead className="bg-slate-50 text-left text-xs uppercase text-slate-500">
          <tr><th className="px-3 py-2">Firma</th><th className="px-3 py-2">Statü</th>
            {kind !== 'unseen' && <><th className="px-3 py-2">Gören</th><th className="px-3 py-2">Görme</th></>}
            {kind === 'acked' && <><th className="px-3 py-2">Onaylayan</th><th className="px-3 py-2">Onay</th></>}</tr>
        </thead>
        <tbody className="divide-y">
          {rows.map(r => (
            <tr key={r.company_id} className="hover:bg-slate-50">
              <td className="px-3 py-2 font-medium text-slate-800">{r.company_name}</td><td className="px-3 py-2 text-slate-500">{r.status_name}</td>
              {kind !== 'unseen' && <><td className="px-3 py-2">{r.seen_by || '-'}</td><td className="px-3 py-2 text-slate-500">{dt(r.seen_at)}</td></>}
              {kind === 'acked' && <><td className="px-3 py-2">{r.acked_by || '-'}</td><td className="px-3 py-2 text-slate-500">{dt(r.acked_at)}</td></>}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
);

export const AnnouncementTracking = ({ a }) => {
  const [data, setData] = useState(null);
  const [q, setQ] = useState('');
  useEffect(() => { axios.get(`${API}/user-announcements/${a.id}/tracking`).then(r => setData(r.data)).catch(() => setData({ acked: [], seen: [], unseen: [] })); }, [a.id]);
  const download = async () => {
    const r = await axios.get(`${API}/user-announcements/${a.id}/tracking.xlsx`, { responseType: 'blob' });
    const url = URL.createObjectURL(r.data);
    Object.assign(document.createElement('a'), { href: url, download: `duyuru-takip-${a.title}.xlsx` }).click();
    URL.revokeObjectURL(url);
  };
  if (!data) return <p className="py-4 text-sm text-slate-400">Yükleniyor...</p>;
  const f = (rows) => rows.filter(r => !q || (r.company_name || '').toLocaleLowerCase('tr').includes(q.toLocaleLowerCase('tr')));
  const tabs = [...(a.mode === 'ack' ? [['acked', 'Okudu ve anladı']] : []), ['seen', a.mode === 'ack' ? 'Gördü, onaylamadı' : 'Gördü'], ['unseen', 'Henüz görmedi']];

  return (
    <Tabs defaultValue={tabs[0][0]} className="space-y-3" data-testid={`ua-tracking-${a.id}`}>
      <div className="flex flex-wrap items-center gap-2">
        <TabsList>{tabs.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`ua-track-tab-${k}`}>{l} ({data[k].length})</TabsTrigger>)}</TabsList>
        <div className="relative ml-auto"><Search className="absolute left-2.5 top-2.5 h-4 w-4 text-slate-400" /><Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Firma ara" className="pl-8 w-56" data-testid="ua-track-search" /></div>
        <Button variant="outline" onClick={download} data-testid="ua-track-excel"><Download className="h-4 w-4 mr-1" />Excel</Button>
      </div>
      {tabs.map(([k]) => <TabsContent key={k} value={k}><Table rows={f(data[k])} kind={k} /></TabsContent>)}
    </Tabs>
  );
};
